export interface WorksCategory {
  id: number
  name: string
  slug: string
}

export interface WorksTag {
  id: number
  name: string
  slug: string
}

export interface WorksImage {
  ID?: number
  id?: number
  url?: string
  alt?: string
  title?: string
  caption?: string
  sizes?: {
    thumbnail?: string
    medium?: string
    large?: string
    full?: string
    [key: string]: string | undefined
  }
  width?: number
  height?: number
}

export interface WorksTextContent {
  acf_fc_layout: 'text'
  chars: string
}

export interface WorksImageContent {
  acf_fc_layout: 'image'
  source: WorksImage
  caption: string
}

export type WorksContent = WorksTextContent | WorksImageContent

export interface WorksCredit {
  kindof: string
  name: string
}

export interface WorksItem {
  id: number
  title: string
  slug: string
  date: string
  modified: string
  link: string
  categories: WorksCategory[]
  tags: WorksTag[]
  featuredImage?: string
  description?: string
  contents?: WorksContent[]
  credits?: WorksCredit[]
  thumbnailUrl: string
  clientTag: string
}

export function getWorksImageSrc(image?: WorksImage): string {
  if (!image) return ''
  if (image.sizes && image.sizes.large) return image.sizes.large
  return image.url || ''
}

export function findFirstWorksImage(contents?: WorksContent[]): WorksImage | undefined {
  if (!contents) return undefined
  const imageContent = contents.find((content): content is WorksImageContent => {
    return content.acf_fc_layout === 'image' && !!(content as WorksImageContent).source
  })
  return imageContent ? imageContent.source : undefined
}

export function formatWorksItem(post: any): WorksItem {
  const embedded = post._embedded || {}
  const terms = embedded['wp:term'] || []
  const categories: any[] = []
  const tags: any[] = []

  terms.forEach((group: any[]) => {
    if (!group || group.length === 0) return
    const taxonomy = group[0].taxonomy
    if (taxonomy === 'category') {
      categories.push(...group)
    } else if (taxonomy === 'post_tag') {
      tags.push(...group)
    }
  })

  const featuredImage = embedded['wp:featuredmedia'] && embedded['wp:featuredmedia'][0]
    ? embedded['wp:featuredmedia'][0].source_url
    : ''

  const contents: WorksContent[] = (post.acf && post.acf.contents) || []
  const firstContentImage = findFirstWorksImage(contents)
  const thumbnailUrl = featuredImage || getWorksImageSrc(firstContentImage) || ''

  return {
    id: post.id,
    title: post.title && post.title.rendered ? post.title.rendered : '',
    slug: post.slug,
    date: post.date,
    modified: post.modified,
    link: post.link,
    categories: categories.map((c: any) => ({ id: c.id, name: c.name, slug: c.slug })),
    tags: tags.map((t: any) => ({ id: t.id, name: t.name, slug: t.slug })),
    featuredImage,
    description: post.acf && post.acf.description ? post.acf.description : '',
    contents,
    credits: (post.acf && post.acf.credits) || [],
    thumbnailUrl,
    clientTag: tags.map((t: any) => t.name).join(' / ')
  }
}
